<template>
    <div class="list-deposit">
        <div class="d-flex justify-content-end mb-3">
            <div class="wrap-filter">
                <b-button class="btn btn-info btn-sm mr-1" @click="isShowFilter = !isShowFilter">Filter</b-button>
            </div>
            <router-link to="/add-deposit" v-if="role == 2">
                <b-button id="show-btn" class="button-add btn-sm"> Add Deposit </b-button>
            </router-link>
        </div>
        <filter-list-deposit v-if="isShowFilter" @setDataFilter="filterTable" :typeTable="typeDeposit"></filter-list-deposit>
        <table>
            <thead>
                <tr id="top">
                    <th scope="col" style="width: 70px">No</th>
                    <th scope="col">Serial Number</th>
                    <th scope="col">Year</th>
                    <th scope="col" style="width: 120px">owner</th>
                    <th scope="col">Hallmark</th>
                    <th scope="col">Fineness</th>
                    <th scope="col">Denom (gr)</th>
                    <th scope="col" style="width: 200px">Deposit Date</th>
                    <!-- <th scope="col">Action</th> -->
                </tr>
            </thead>
            <tbody v-if="isLoadingData">
                <tr>
                    <td colspan="7">
                        <b-spinner></b-spinner>
                    </td>
                </tr>
            </tbody>
            <tbody v-else>
                <tr v-for="(data, i) in depositData" :key="i" v-show="depositData != 0">
                    <td data-label="No">{{ (pageNumber - 1) * totalPerPage + (i + 1) }}</td>
                   <td data-label="Serial Number">{{ data.serial_number }}</td>
                    <td data-label="Year">{{ data.year }}</td>
                    <td data-label="Owner">{{ data.owner }}</td>
                    <td data-label="Hallmark">{{ data.hallmark }}</td>
                    <td data-label="Fineness">{{ data.fineness }}</td>
                    <td data-label="Weight">{{ data.weight }}</td>
                    <td data-label="Deposite Date">{{ data.created_at | formatDate }}</td> 
                </tr>
                <tr v-show="depositData.length == 0">
                    <td colspan="7">No Data Available in Table</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import FilterListDeposit from "../utility/filter/FilterListDeposit.vue";
export default {
    components: { FilterListDeposit },
    props: {
        depositData: Array,
        typeDeposit: {
            type: String,
            default: "onexchange",
        },
        pageNumber: Number,
        totalPerPage: Number,
        totalDeposit: Number,
        isLoadingData: Boolean,
    },
    data() {
        return {
            role: sessionStorage.getItem("role"),
            isShowFilter: false,
            serialNumber: "",
            perPage: 10,
            currentPage: 1,
            owner: "",
            startDate: "",
            endDate: "",
            status: "",
        };
    },
    mounted() {},
    methods: {
        checkDecimal(value) {
            if (Number.isInteger(value)) {
                return value;
            } else {
                let lengthDecimal = value.toString().split(".")[1].length;
                let newValue;
                if (lengthDecimal > 2) {
                    newValue = value.toFixed(2);
                } else {
                    newValue = value;
                }
                return newValue;
            }
        },
        filterTable(event) {
            this.$emit("setFilterTable", event);
        },
    },
};
</script>

<style></style>
